import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import Layout from '@/components/layouts/Layout';
import LandingPageLayout from '@/components/layouts/LandingPageLayout';
import Contact from '@/pages/Contact';
import { ContentProvider } from '@/hooks/useCms';

function ContactView() {
  const { inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  if (inProgress !== InteractionStatus.None) {
    return null;
  }

  if (isAuthenticated) {
    return (
      <ContentProvider>
        <Layout>
          <Contact />
        </Layout>
      </ContentProvider>
    );
  } else {
    return (
      <LandingPageLayout>
        <Contact />
      </LandingPageLayout>
    );
  }
}

export default ContactView;
